import { ProductionDivisionMock } from "./productionDivision.mock";

const salesPotashMock = {
    "title": "Sales",
    "type": "Sales",
    "navigation": {
        "type": "GraphNavigation",
        "nav": {
            "month": [
                {
                    "title": "LY",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 146.0,
                                                "percent": 35.0
                                            },
                                            "compare": {
                                                "value": 108.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 141.0,
                                                "percent": -42.0
                                            },
                                            "compare": {
                                                "value": 244.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 443.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 168.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 411.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 373.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 252.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 274.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 328.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 139.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 288.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 286.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 24.0,
                                                "columns": [
                                                    94.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 115.0,
                                                "columns": [
                                                    42.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -22.0,
                                                "columns": [
                                                    16.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 23.0,
                                                "columns": [
                                                    -6.0,
                                                    -7.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -52.0,
                                                "columns": [
                                                    96.0,
                                                    202.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 57.0,
                                                "columns": [
                                                    37.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -44.0,
                                                "columns": [
                                                    14.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 6.0,
                                                "columns": [
                                                    -6.0,
                                                    -6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    333.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    94.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    107.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    49.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    341.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    275.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    84.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    213.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -10.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    215.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -8.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    256.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    53.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -7.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -7.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    213.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    53.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -10.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    214.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    55.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -7.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 94.0,
                                                "percent": 24.0
                                            },
                                            "compare": {
                                                "value": 76.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 96.0,
                                                "percent": -52.0
                                            },
                                            "compare": {
                                                "value": 202.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 333.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 107.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 341.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 275.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 213.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 215.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 256.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 213.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 214.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 24.0,
                                                "columns": [
                                                    94.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 115.0,
                                                "columns": [
                                                    42.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -22.0,
                                                "columns": [
                                                    16.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 23.0,
                                                "columns": [
                                                    -6.0,
                                                    -7.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -52.0,
                                                "columns": [
                                                    96.0,
                                                    202.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 57.0,
                                                "columns": [
                                                    37.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -44.0,
                                                "columns": [
                                                    14.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 6.0,
                                                "columns": [
                                                    -6.0,
                                                    -6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    333.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    94.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    107.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    49.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    341.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    275.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    84.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    213.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -10.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    215.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -8.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    256.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    53.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -7.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -7.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    213.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    53.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -10.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    214.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    55.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -7.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IBP",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 42.0,
                                                "percent": 115.0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 37.0,
                                                "percent": 57.0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 94.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 49.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 52.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 84.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 53.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 53.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 55.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 24.0,
                                                "columns": [
                                                    94.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 115.0,
                                                "columns": [
                                                    42.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -22.0,
                                                "columns": [
                                                    16.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 23.0,
                                                "columns": [
                                                    -6.0,
                                                    -7.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -52.0,
                                                "columns": [
                                                    96.0,
                                                    202.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 57.0,
                                                "columns": [
                                                    37.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -44.0,
                                                "columns": [
                                                    14.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 6.0,
                                                "columns": [
                                                    -6.0,
                                                    -6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    333.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    94.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    107.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    49.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    341.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    275.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    84.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    213.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -10.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    215.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -8.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    256.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    53.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -7.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -7.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    213.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    53.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -10.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    214.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    55.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -7.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "DSM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 16.0,
                                                "percent": -22.0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 14.0,
                                                "percent": -44.0
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 29.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 27.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 26.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 24.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 32.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 24.0,
                                                "columns": [
                                                    94.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 115.0,
                                                "columns": [
                                                    42.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -22.0,
                                                "columns": [
                                                    16.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 23.0,
                                                "columns": [
                                                    -6.0,
                                                    -7.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -52.0,
                                                "columns": [
                                                    96.0,
                                                    202.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 57.0,
                                                "columns": [
                                                    37.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -44.0,
                                                "columns": [
                                                    14.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 6.0,
                                                "columns": [
                                                    -6.0,
                                                    -6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    333.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    94.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    107.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    49.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    341.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    275.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    84.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    213.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -10.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    215.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -8.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    256.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    53.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -7.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -7.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    213.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    53.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -10.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    214.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    55.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -7.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -6.0,
                                                "percent": 23.0
                                            },
                                            "compare": {
                                                "value": -7.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -6.0,
                                                "percent": 6.0
                                            },
                                            "compare": {
                                                "value": -6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -7.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -7.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -7.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 24.0,
                                                "columns": [
                                                    94.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 115.0,
                                                "columns": [
                                                    42.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -22.0,
                                                "columns": [
                                                    16.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 23.0,
                                                "columns": [
                                                    -6.0,
                                                    -7.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -52.0,
                                                "columns": [
                                                    96.0,
                                                    202.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 57.0,
                                                "columns": [
                                                    37.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -44.0,
                                                "columns": [
                                                    14.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 6.0,
                                                "columns": [
                                                    -6.0,
                                                    -6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    333.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    94.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    107.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    49.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    341.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    275.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    84.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    213.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -10.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    215.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -8.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    256.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    53.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -7.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -7.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    213.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    53.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -10.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    214.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    55.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -7.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 146.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 108.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 141.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 244.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 443.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 168.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 411.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 373.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 252.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 274.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 328.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 139.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 288.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 286.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -56.0,
                                                "columns": [
                                                    94.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -23.0,
                                                "columns": [
                                                    42.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -32.0,
                                                "columns": [
                                                    16.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -18.0,
                                                "columns": [
                                                    -6.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 2.0,
                                                "columns": [
                                                    96.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -13.0,
                                                "columns": [
                                                    37.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -12.0,
                                                "columns": [
                                                    14.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    -6.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 94.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 214.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 96.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 94.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 96.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -56.0,
                                                "columns": [
                                                    94.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -23.0,
                                                "columns": [
                                                    42.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -32.0,
                                                "columns": [
                                                    16.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -18.0,
                                                "columns": [
                                                    -6.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 2.0,
                                                "columns": [
                                                    96.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -13.0,
                                                "columns": [
                                                    37.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -12.0,
                                                "columns": [
                                                    14.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    -6.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IBP",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 55.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -56.0,
                                                "columns": [
                                                    94.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -23.0,
                                                "columns": [
                                                    42.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -32.0,
                                                "columns": [
                                                    16.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -18.0,
                                                "columns": [
                                                    -6.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 2.0,
                                                "columns": [
                                                    96.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -13.0,
                                                "columns": [
                                                    37.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -12.0,
                                                "columns": [
                                                    14.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    -6.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "DSM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 16.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 14.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 16.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -56.0,
                                                "columns": [
                                                    94.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -23.0,
                                                "columns": [
                                                    42.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -32.0,
                                                "columns": [
                                                    16.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -18.0,
                                                "columns": [
                                                    -6.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 2.0,
                                                "columns": [
                                                    96.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -13.0,
                                                "columns": [
                                                    37.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -12.0,
                                                "columns": [
                                                    14.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    -6.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -6.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": -7.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -6.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": -6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": -6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -56.0,
                                                "columns": [
                                                    94.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -23.0,
                                                "columns": [
                                                    42.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -32.0,
                                                "columns": [
                                                    16.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -18.0,
                                                "columns": [
                                                    -6.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 2.0,
                                                "columns": [
                                                    96.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -13.0,
                                                "columns": [
                                                    37.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -12.0,
                                                "columns": [
                                                    14.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    -6.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 146.0,
                                                "percent": -33.0
                                            },
                                            "compare": {
                                                "value": 108.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 141.0,
                                                "percent": -32.0
                                            },
                                            "compare": {
                                                "value": 244.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 443.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 168.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 411.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 373.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 252.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 274.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 328.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 139.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 288.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 286.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -38.0,
                                                "columns": [
                                                    94.0,
                                                    151.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -4.0,
                                                "columns": [
                                                    42.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -34.0,
                                                "columns": [
                                                    16.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    -6.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -35.0,
                                                "columns": [
                                                    96.0,
                                                    147.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -1.0,
                                                "columns": [
                                                    37.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -42.0,
                                                "columns": [
                                                    14.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    -6.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    141.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    56.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    124.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    164.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    155.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    168.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    189.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    166.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    139.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    156.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    49.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    151.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 94.0,
                                                "percent": -38.0
                                            },
                                            "compare": {
                                                "value": 76.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 96.0,
                                                "percent": -35.0
                                            },
                                            "compare": {
                                                "value": 202.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 333.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 107.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 341.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 275.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 213.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 215.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 256.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 213.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 214.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -38.0,
                                                "columns": [
                                                    94.0,
                                                    151.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -4.0,
                                                "columns": [
                                                    42.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -34.0,
                                                "columns": [
                                                    16.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    -6.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -35.0,
                                                "columns": [
                                                    96.0,
                                                    147.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -1.0,
                                                "columns": [
                                                    37.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -42.0,
                                                "columns": [
                                                    14.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    -6.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    141.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    56.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    124.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    164.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    155.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    168.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    189.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    166.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    139.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    156.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    49.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    151.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IBP",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 42.0,
                                                "percent": -4.0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 37.0,
                                                "percent": -1.0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 94.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 49.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 52.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 84.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 53.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 53.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 55.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -38.0,
                                                "columns": [
                                                    94.0,
                                                    151.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -4.0,
                                                "columns": [
                                                    42.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -34.0,
                                                "columns": [
                                                    16.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    -6.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -35.0,
                                                "columns": [
                                                    96.0,
                                                    147.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -1.0,
                                                "columns": [
                                                    37.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -42.0,
                                                "columns": [
                                                    14.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    -6.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    141.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    56.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    124.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    164.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    155.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    168.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    189.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    166.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    139.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    156.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    49.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    151.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "DSM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 16.0,
                                                "percent": -34.0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 14.0,
                                                "percent": -42.0
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 29.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 27.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 26.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 24.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 32.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -38.0,
                                                "columns": [
                                                    94.0,
                                                    151.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -4.0,
                                                "columns": [
                                                    42.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -34.0,
                                                "columns": [
                                                    16.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    -6.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -35.0,
                                                "columns": [
                                                    96.0,
                                                    147.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -1.0,
                                                "columns": [
                                                    37.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -42.0,
                                                "columns": [
                                                    14.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    -6.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    141.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    56.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    124.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    164.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    155.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    168.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    189.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    166.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    139.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    156.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    49.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    151.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -6.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -7.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -6.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -7.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -7.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -7.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -38.0,
                                                "columns": [
                                                    94.0,
                                                    151.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -4.0,
                                                "columns": [
                                                    42.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -34.0,
                                                "columns": [
                                                    16.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    -6.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -35.0,
                                                "columns": [
                                                    96.0,
                                                    147.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -1.0,
                                                "columns": [
                                                    37.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -42.0,
                                                "columns": [
                                                    14.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    -6.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    141.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    56.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    124.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    164.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    155.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    168.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    189.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    166.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    139.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    156.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    49.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    151.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                }
            ],
            "qtd": [
                {
                    "title": "LY",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 287.0,
                                                "percent": -18.0
                                            },
                                            "compare": {
                                                "value": 352.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 795.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 951.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 854.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 713.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -32.0,
                                                "columns": [
                                                    190.0,
                                                    277.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 83.0,
                                                "columns": [
                                                    79.0,
                                                    43.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -34.0,
                                                "columns": [
                                                    30.0,
                                                    45.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 16.0,
                                                "columns": [
                                                    -11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    610.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    137.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    67.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    723.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    185.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    684.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    113.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    82.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -25.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    508.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    149.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -24.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 190.0,
                                                "percent": -32.0
                                            },
                                            "compare": {
                                                "value": 277.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 610.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 723.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 684.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 508.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -32.0,
                                                "columns": [
                                                    190.0,
                                                    277.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 83.0,
                                                "columns": [
                                                    79.0,
                                                    43.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -34.0,
                                                "columns": [
                                                    30.0,
                                                    45.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 16.0,
                                                "columns": [
                                                    -11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    610.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    137.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    67.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    723.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    185.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    684.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    113.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    82.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -25.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    508.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    149.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -24.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IBP",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 79.0,
                                                "percent": 83.0
                                            },
                                            "compare": {
                                                "value": 43.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 137.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 185.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 113.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 149.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -32.0,
                                                "columns": [
                                                    190.0,
                                                    277.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 83.0,
                                                "columns": [
                                                    79.0,
                                                    43.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -34.0,
                                                "columns": [
                                                    30.0,
                                                    45.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 16.0,
                                                "columns": [
                                                    -11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    610.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    137.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    67.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    723.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    185.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    684.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    113.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    82.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -25.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    508.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    149.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -24.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "DSM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 30.0,
                                                "percent": -34.0
                                            },
                                            "compare": {
                                                "value": 45.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 67.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 62.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 82.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -32.0,
                                                "columns": [
                                                    190.0,
                                                    277.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 83.0,
                                                "columns": [
                                                    79.0,
                                                    43.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -34.0,
                                                "columns": [
                                                    30.0,
                                                    45.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 16.0,
                                                "columns": [
                                                    -11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    610.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    137.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    67.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    723.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    185.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    684.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    113.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    82.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -25.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    508.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    149.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -24.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -11.0,
                                                "percent": 16.0
                                            },
                                            "compare": {
                                                "value": -13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -24.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -32.0,
                                                "columns": [
                                                    190.0,
                                                    277.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 83.0,
                                                "columns": [
                                                    79.0,
                                                    43.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -34.0,
                                                "columns": [
                                                    30.0,
                                                    45.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 16.0,
                                                "columns": [
                                                    -11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    610.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    137.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    67.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    723.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    185.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    684.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    113.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    82.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -25.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    508.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    149.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -24.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 287.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 352.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 795.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 951.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 854.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 713.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -35.0,
                                                "columns": [
                                                    190.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -17.0,
                                                "columns": [
                                                    79.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -47.0,
                                                "columns": [
                                                    30.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -32.0,
                                                "columns": [
                                                    -11.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 190.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 294.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 508.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -35.0,
                                                "columns": [
                                                    190.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -17.0,
                                                "columns": [
                                                    79.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -47.0,
                                                "columns": [
                                                    30.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -32.0,
                                                "columns": [
                                                    -11.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IBP",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 94.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 149.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -35.0,
                                                "columns": [
                                                    190.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -17.0,
                                                "columns": [
                                                    79.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -47.0,
                                                "columns": [
                                                    30.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -32.0,
                                                "columns": [
                                                    -11.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "DSM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 56.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -35.0,
                                                "columns": [
                                                    190.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -17.0,
                                                "columns": [
                                                    79.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -47.0,
                                                "columns": [
                                                    30.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -32.0,
                                                "columns": [
                                                    -11.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -11.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": -24.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -35.0,
                                                "columns": [
                                                    190.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -17.0,
                                                "columns": [
                                                    79.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -47.0,
                                                "columns": [
                                                    30.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -32.0,
                                                "columns": [
                                                    -11.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 287.0,
                                                "percent": -33.0
                                            },
                                            "compare": {
                                                "value": 352.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 795.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 951.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 854.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 713.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -36.0,
                                                "columns": [
                                                    190.0,
                                                    298.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -3.0,
                                                "columns": [
                                                    79.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -38.0,
                                                "columns": [
                                                    30.0,
                                                    48.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    -11.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    439.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    137.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    73.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    443.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    119.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    523.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    115.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    446.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    110.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 190.0,
                                                "percent": -36.0
                                            },
                                            "compare": {
                                                "value": 277.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 610.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 723.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 684.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 508.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -36.0,
                                                "columns": [
                                                    190.0,
                                                    298.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -3.0,
                                                "columns": [
                                                    79.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -38.0,
                                                "columns": [
                                                    30.0,
                                                    48.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    -11.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    439.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    137.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    73.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    443.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    119.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    523.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    115.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    446.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    110.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IBP",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 79.0,
                                                "percent": -3.0
                                            },
                                            "compare": {
                                                "value": 43.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 137.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 185.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 113.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 149.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -36.0,
                                                "columns": [
                                                    190.0,
                                                    298.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -3.0,
                                                "columns": [
                                                    79.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -38.0,
                                                "columns": [
                                                    30.0,
                                                    48.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    -11.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    439.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    137.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    73.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    443.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    119.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    523.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    115.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    446.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    110.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "DSM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 30.0,
                                                "percent": -38.0
                                            },
                                            "compare": {
                                                "value": 45.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 67.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 62.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 82.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -36.0,
                                                "columns": [
                                                    190.0,
                                                    298.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -3.0,
                                                "columns": [
                                                    79.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -38.0,
                                                "columns": [
                                                    30.0,
                                                    48.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    -11.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    439.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    137.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    73.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    443.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    119.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    523.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    115.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    446.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    110.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -11.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -24.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -36.0,
                                                "columns": [
                                                    190.0,
                                                    298.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -3.0,
                                                "columns": [
                                                    79.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -38.0,
                                                "columns": [
                                                    30.0,
                                                    48.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    -11.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    439.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    137.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    73.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    443.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    119.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    523.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    115.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    446.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    110.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                }
            ],
            "ytd": [
                {
                    "title": "LY",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 146.0,
                                                "percent": 35.0
                                            },
                                            "compare": {
                                                "value": 108.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 287.0,
                                                "percent": -18.0
                                            },
                                            "compare": {
                                                "value": 352.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 795.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 963.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1374.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1746.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1998.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2272.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2600.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2739.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 3027.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 3313.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 24.0,
                                                "columns": [
                                                    94.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 115.0,
                                                "columns": [
                                                    42.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -22.0,
                                                "columns": [
                                                    16.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 23.0,
                                                "columns": [
                                                    -6.0,
                                                    -7.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -32.0,
                                                "columns": [
                                                    190.0,
                                                    277.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 83.0,
                                                "columns": [
                                                    79.0,
                                                    43.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -34.0,
                                                "columns": [
                                                    30.0,
                                                    45.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 16.0,
                                                "columns": [
                                                    -11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    610.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    137.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    67.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    717.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    186.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    86.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -25.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1058.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    238.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    109.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -32.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1333.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    321.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    129.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -38.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1546.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    341.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    158.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -47.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1762.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    382.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    185.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -56.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2017.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    435.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    211.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -63.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2098.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    476.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    235.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -69.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2311.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    529.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    267.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -79.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2525.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    584.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    290.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -86.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 94.0,
                                                "percent": 24.0
                                            },
                                            "compare": {
                                                "value": 76.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 190.0,
                                                "percent": -32.0
                                            },
                                            "compare": {
                                                "value": 277.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 610.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 717.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1058.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1333.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1546.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1762.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2017.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2098.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2311.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2525.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 24.0,
                                                "columns": [
                                                    94.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 115.0,
                                                "columns": [
                                                    42.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -22.0,
                                                "columns": [
                                                    16.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 23.0,
                                                "columns": [
                                                    -6.0,
                                                    -7.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -32.0,
                                                "columns": [
                                                    190.0,
                                                    277.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 83.0,
                                                "columns": [
                                                    79.0,
                                                    43.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -34.0,
                                                "columns": [
                                                    30.0,
                                                    45.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 16.0,
                                                "columns": [
                                                    -11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    610.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    137.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    67.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    717.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    186.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    86.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -25.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1058.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    238.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    109.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -32.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1333.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    321.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    129.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -38.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1546.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    341.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    158.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -47.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1762.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    382.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    185.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -56.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2017.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    435.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    211.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -63.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2098.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    476.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    235.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -69.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2311.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    529.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    267.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -79.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2525.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    584.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    290.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -86.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IBP",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 42.0,
                                                "percent": 115.0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 79.0,
                                                "percent": 83.0
                                            },
                                            "compare": {
                                                "value": 43.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 137.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 186.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 238.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 321.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 341.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 382.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 435.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 476.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 529.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 584.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 24.0,
                                                "columns": [
                                                    94.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 115.0,
                                                "columns": [
                                                    42.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -22.0,
                                                "columns": [
                                                    16.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 23.0,
                                                "columns": [
                                                    -6.0,
                                                    -7.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -32.0,
                                                "columns": [
                                                    190.0,
                                                    277.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 83.0,
                                                "columns": [
                                                    79.0,
                                                    43.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -34.0,
                                                "columns": [
                                                    30.0,
                                                    45.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 16.0,
                                                "columns": [
                                                    -11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    610.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    137.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    67.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    717.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    186.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    86.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -25.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1058.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    238.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    109.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -32.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1333.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    321.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    129.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -38.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1546.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    341.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    158.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -47.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1762.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    382.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    185.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -56.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2017.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    435.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    211.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -63.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2098.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    476.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    235.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -69.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2311.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    529.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    267.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -79.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2525.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    584.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    290.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -86.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "DSM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 16.0,
                                                "percent": -22.0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 30.0,
                                                "percent": -34.0
                                            },
                                            "compare": {
                                                "value": 45.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 67.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 86.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 109.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 129.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 158.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 185.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 211.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 235.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 267.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 290.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 24.0,
                                                "columns": [
                                                    94.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 115.0,
                                                "columns": [
                                                    42.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -22.0,
                                                "columns": [
                                                    16.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 23.0,
                                                "columns": [
                                                    -6.0,
                                                    -7.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -32.0,
                                                "columns": [
                                                    190.0,
                                                    277.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 83.0,
                                                "columns": [
                                                    79.0,
                                                    43.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -34.0,
                                                "columns": [
                                                    30.0,
                                                    45.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 16.0,
                                                "columns": [
                                                    -11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    610.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    137.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    67.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    717.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    186.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    86.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -25.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1058.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    238.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    109.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -32.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1333.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    321.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    129.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -38.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1546.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    341.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    158.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -47.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1762.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    382.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    185.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -56.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2017.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    435.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    211.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -63.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2098.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    476.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    235.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -69.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2311.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    529.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    267.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -79.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2525.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    584.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    290.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -86.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -6.0,
                                                "percent": 23.0
                                            },
                                            "compare": {
                                                "value": -7.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -11.0,
                                                "percent": 16.0
                                            },
                                            "compare": {
                                                "value": -13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -32.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -38.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -47.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -56.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -63.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -69.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -86.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 24.0,
                                                "columns": [
                                                    94.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 115.0,
                                                "columns": [
                                                    42.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -22.0,
                                                "columns": [
                                                    16.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 23.0,
                                                "columns": [
                                                    -6.0,
                                                    -7.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -32.0,
                                                "columns": [
                                                    190.0,
                                                    277.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 83.0,
                                                "columns": [
                                                    79.0,
                                                    43.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -34.0,
                                                "columns": [
                                                    30.0,
                                                    45.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 16.0,
                                                "columns": [
                                                    -11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    610.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    137.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    67.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    717.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    186.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    86.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -25.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1058.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    238.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    109.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -32.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1333.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    321.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    129.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -38.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1546.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    341.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    158.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -47.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1762.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    382.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    185.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -56.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2017.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    435.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    211.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -63.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2098.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    476.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    235.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -69.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2311.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    529.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    267.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -79.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2525.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    584.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    290.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -86.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 146.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 108.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 287.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 352.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 795.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 963.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 1374.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 1746.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 1998.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 2272.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 2600.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 2739.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 3027.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 3313.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    94.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    42.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    16.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    -6.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    190.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    79.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    30.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    -11.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 94.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 2525.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 190.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 94.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 190.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    94.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    42.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    16.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    -6.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    190.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    79.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    30.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    -11.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IBP",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 584.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    94.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    42.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    16.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    -6.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    190.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    79.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    30.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    -11.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "DSM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 16.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 290.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 16.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    94.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    42.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    16.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    -6.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    190.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    79.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    30.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    -11.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -6.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": -86.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -11.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": -6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": -11.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    94.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    42.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    16.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    -6.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    190.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    79.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    30.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    -11.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 146.0,
                                                "percent": -33.0
                                            },
                                            "compare": {
                                                "value": 108.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 287.0,
                                                "percent": -33.0
                                            },
                                            "compare": {
                                                "value": 352.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 795.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 963.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1374.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1746.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1998.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2272.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2600.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2739.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 3027.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 3313.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -38.0,
                                                "columns": [
                                                    94.0,
                                                    151.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -4.0,
                                                "columns": [
                                                    42.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -34.0,
                                                "columns": [
                                                    16.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    -6.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -36.0,
                                                "columns": [
                                                    190.0,
                                                    298.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -3.0,
                                                "columns": [
                                                    79.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -38.0,
                                                "columns": [
                                                    30.0,
                                                    48.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    -11.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    439.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    137.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    73.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    563.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    174.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    727.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    206.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    122.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    882.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    256.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    147.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1050.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    297.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    172.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1239.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    334.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    196.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1405.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    371.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    221.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1544.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    404.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    246.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1700.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    453.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    270.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1851.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    481.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    297.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 94.0,
                                                "percent": -38.0
                                            },
                                            "compare": {
                                                "value": 76.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 190.0,
                                                "percent": -36.0
                                            },
                                            "compare": {
                                                "value": 277.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 610.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 717.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1058.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1333.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1546.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1762.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2017.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2098.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2311.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2525.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -38.0,
                                                "columns": [
                                                    94.0,
                                                    151.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -4.0,
                                                "columns": [
                                                    42.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -34.0,
                                                "columns": [
                                                    16.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    -6.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -36.0,
                                                "columns": [
                                                    190.0,
                                                    298.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -3.0,
                                                "columns": [
                                                    79.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -38.0,
                                                "columns": [
                                                    30.0,
                                                    48.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    -11.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    439.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    137.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    73.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    563.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    174.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    727.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    206.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    122.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    882.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    256.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    147.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1050.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    297.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    172.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1239.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    334.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    196.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1405.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    371.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    221.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1544.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    404.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    246.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1700.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    453.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    270.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1851.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    481.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    297.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IBP",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 42.0,
                                                "percent": -4.0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 79.0,
                                                "percent": -3.0
                                            },
                                            "compare": {
                                                "value": 43.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 137.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 186.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 238.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 321.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 341.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 382.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 435.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 476.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 529.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 584.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -38.0,
                                                "columns": [
                                                    94.0,
                                                    151.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -4.0,
                                                "columns": [
                                                    42.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -34.0,
                                                "columns": [
                                                    16.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    -6.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -36.0,
                                                "columns": [
                                                    190.0,
                                                    298.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -3.0,
                                                "columns": [
                                                    79.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -38.0,
                                                "columns": [
                                                    30.0,
                                                    48.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    -11.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    439.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    137.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    73.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    563.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    174.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    727.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    206.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    122.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    882.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    256.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    147.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1050.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    297.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    172.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1239.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    334.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    196.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1405.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    371.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    221.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1544.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    404.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    246.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1700.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    453.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    270.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1851.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    481.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    297.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "DSM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 16.0,
                                                "percent": -34.0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 30.0,
                                                "percent": -38.0
                                            },
                                            "compare": {
                                                "value": 45.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 67.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 86.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 109.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 129.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 158.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 185.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 211.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 235.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 267.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 290.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -38.0,
                                                "columns": [
                                                    94.0,
                                                    151.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -4.0,
                                                "columns": [
                                                    42.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -34.0,
                                                "columns": [
                                                    16.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    -6.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -36.0,
                                                "columns": [
                                                    190.0,
                                                    298.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -3.0,
                                                "columns": [
                                                    79.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -38.0,
                                                "columns": [
                                                    30.0,
                                                    48.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    -11.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    439.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    137.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    73.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    563.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    174.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    727.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    206.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    122.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    882.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    256.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    147.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1050.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    297.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    172.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1239.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    334.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    196.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1405.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    371.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    221.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1544.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    404.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    246.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1700.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    453.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    270.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1851.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    481.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    297.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -6.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -7.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -11.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -32.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -38.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -47.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -56.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -63.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -69.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -86.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -38.0,
                                                "columns": [
                                                    94.0,
                                                    151.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -4.0,
                                                "columns": [
                                                    42.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -34.0,
                                                "columns": [
                                                    16.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    -6.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -36.0,
                                                "columns": [
                                                    190.0,
                                                    298.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -3.0,
                                                "columns": [
                                                    79.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -38.0,
                                                "columns": [
                                                    30.0,
                                                    48.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    -11.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    439.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    137.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    73.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    563.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    174.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    727.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    206.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    122.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    882.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    256.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    147.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1050.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    297.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    172.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1239.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    334.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    196.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1405.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    371.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    221.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1544.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    404.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    246.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1700.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    453.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    270.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1851.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    481.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    297.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                }
            ]
        }
    },
    subMenu: [
        {
          // NavigationItem
          title: 'Total',
        },
        {
          // NavigationItem
          title: 'IL',
        },
        {
          // NavigationItem
          title: 'IBP',
        },
        {
          // NavigationItem
          title: 'DSM',
        },
        {
          // NavigationItem
          title: 'OTH',
        },
      ],
};

const ebitdaPotashMock = {
    "title": "EBITDA",
    "type": "EBITDA",
    "navigation": {
        "type": "GraphNavigation",
        "nav": {
            "month": [
                {
                    "title": "LY",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 69.0,
                                                "percent": 19.0
                                            },
                                            "compare": {
                                                "value": 58.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 62.0,
                                                "percent": -55.0
                                            },
                                            "compare": {
                                                "value": 136.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 257.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 93.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 275.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 247.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 162.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 167.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 209.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 67.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 162.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 156.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 16.0,
                                                "columns": [
                                                    51.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 41.0,
                                                "columns": [
                                                    15.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -23.0,
                                                "columns": [
                                                    2.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 648.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -61.0,
                                                "columns": [
                                                    47.0,
                                                    121.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 43.0,
                                                "columns": [
                                                    12.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -67.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 1677.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    237.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    195.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    48.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    150.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    140.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    166.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 51.0,
                                                "percent": 16.0
                                            },
                                            "compare": {
                                                "value": 44.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 47.0,
                                                "percent": -61.0
                                            },
                                            "compare": {
                                                "value": 121.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 208.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 237.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 195.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 150.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 140.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 166.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 125.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 144.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 16.0,
                                                "columns": [
                                                    51.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 41.0,
                                                "columns": [
                                                    15.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -23.0,
                                                "columns": [
                                                    2.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 648.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -61.0,
                                                "columns": [
                                                    47.0,
                                                    121.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 43.0,
                                                "columns": [
                                                    12.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -67.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 1677.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    237.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    195.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    48.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    150.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    140.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    166.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IBP",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 15.0,
                                                "percent": 41.0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 12.0,
                                                "percent": 43.0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 26.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 48.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 21.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 27.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 16.0,
                                                "columns": [
                                                    51.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 41.0,
                                                "columns": [
                                                    15.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -23.0,
                                                "columns": [
                                                    2.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 648.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -61.0,
                                                "columns": [
                                                    47.0,
                                                    121.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 43.0,
                                                "columns": [
                                                    12.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -67.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 1677.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    237.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    195.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    48.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    150.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    140.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    166.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "DSM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 2.0,
                                                "percent": -23.0
                                            },
                                            "compare": {
                                                "value": 3.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 2.0,
                                                "percent": -67.0
                                            },
                                            "compare": {
                                                "value": 7.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 16.0,
                                                "columns": [
                                                    51.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 41.0,
                                                "columns": [
                                                    15.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -23.0,
                                                "columns": [
                                                    2.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 648.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -61.0,
                                                "columns": [
                                                    47.0,
                                                    121.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 43.0,
                                                "columns": [
                                                    12.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -67.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 1677.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    237.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    195.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    48.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    150.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    140.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    166.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 648.0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 1677.0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 16.0,
                                                "columns": [
                                                    51.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 41.0,
                                                "columns": [
                                                    15.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -23.0,
                                                "columns": [
                                                    2.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 648.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -61.0,
                                                "columns": [
                                                    47.0,
                                                    121.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 43.0,
                                                "columns": [
                                                    12.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -67.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 1677.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    237.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    195.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    48.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    150.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    140.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    166.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 69.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 58.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 62.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 136.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 257.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 93.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 275.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 247.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 162.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 167.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 209.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 67.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 162.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 156.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -64.0,
                                                "columns": [
                                                    51.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 309.0,
                                                "columns": [
                                                    15.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -73.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -944.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -8.0,
                                                "columns": [
                                                    47.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -20.0,
                                                "columns": [
                                                    12.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 5.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -25.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 51.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 144.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 47.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 51.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 47.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -64.0,
                                                "columns": [
                                                    51.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 309.0,
                                                "columns": [
                                                    15.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -73.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -944.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -8.0,
                                                "columns": [
                                                    47.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -20.0,
                                                "columns": [
                                                    12.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 5.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -25.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IBP",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 15.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 12.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 12.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -64.0,
                                                "columns": [
                                                    51.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 309.0,
                                                "columns": [
                                                    15.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -73.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -944.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -8.0,
                                                "columns": [
                                                    47.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -20.0,
                                                "columns": [
                                                    12.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 5.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -25.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "DSM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -64.0,
                                                "columns": [
                                                    51.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 309.0,
                                                "columns": [
                                                    15.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -73.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -944.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -8.0,
                                                "columns": [
                                                    47.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -20.0,
                                                "columns": [
                                                    12.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 5.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -25.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -64.0,
                                                "columns": [
                                                    51.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 309.0,
                                                "columns": [
                                                    15.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -73.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -944.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -8.0,
                                                "columns": [
                                                    47.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -20.0,
                                                "columns": [
                                                    12.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 5.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -25.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 69.0,
                                                "percent": -31.0
                                            },
                                            "compare": {
                                                "value": 58.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 62.0,
                                                "percent": -31.0
                                            },
                                            "compare": {
                                                "value": 136.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 257.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 93.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 275.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 247.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 162.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 167.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 209.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 67.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 162.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 156.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -32.0,
                                                "columns": [
                                                    51.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 23.0,
                                                "columns": [
                                                    15.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -81.0,
                                                "columns": [
                                                    2.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -36.0,
                                                "columns": [
                                                    47.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 31.0,
                                                "columns": [
                                                    12.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -66.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    83.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 51.0,
                                                "percent": -32.0
                                            },
                                            "compare": {
                                                "value": 44.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 47.0,
                                                "percent": -36.0
                                            },
                                            "compare": {
                                                "value": 121.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 208.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 237.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 195.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 150.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 140.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 166.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 125.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 144.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -32.0,
                                                "columns": [
                                                    51.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 23.0,
                                                "columns": [
                                                    15.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -81.0,
                                                "columns": [
                                                    2.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -36.0,
                                                "columns": [
                                                    47.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 31.0,
                                                "columns": [
                                                    12.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -66.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    83.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IBP",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 15.0,
                                                "percent": 23.0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 12.0,
                                                "percent": 31.0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 26.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 48.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 21.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 27.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -32.0,
                                                "columns": [
                                                    51.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 23.0,
                                                "columns": [
                                                    15.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -81.0,
                                                "columns": [
                                                    2.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -36.0,
                                                "columns": [
                                                    47.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 31.0,
                                                "columns": [
                                                    12.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -66.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    83.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "DSM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 2.0,
                                                "percent": -81.0
                                            },
                                            "compare": {
                                                "value": 3.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 2.0,
                                                "percent": -66.0
                                            },
                                            "compare": {
                                                "value": 7.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -32.0,
                                                "columns": [
                                                    51.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 23.0,
                                                "columns": [
                                                    15.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -81.0,
                                                "columns": [
                                                    2.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -36.0,
                                                "columns": [
                                                    47.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 31.0,
                                                "columns": [
                                                    12.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -66.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    83.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -32.0,
                                                "columns": [
                                                    51.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 23.0,
                                                "columns": [
                                                    15.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -81.0,
                                                "columns": [
                                                    2.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -36.0,
                                                "columns": [
                                                    47.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 31.0,
                                                "columns": [
                                                    12.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -66.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    83.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                }
            ],
            "qtd": [
                {
                    "title": "LY",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 69.0,
                                                "percent": 19.0
                                            },
                                            "compare": {
                                                "value": 58.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 62.0,
                                                "percent": -55.0
                                            },
                                            "compare": {
                                                "value": 136.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 257.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 93.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 275.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 247.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 162.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 167.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 209.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 67.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 162.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 156.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 16.0,
                                                "columns": [
                                                    51.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 41.0,
                                                "columns": [
                                                    15.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -23.0,
                                                "columns": [
                                                    2.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 648.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -61.0,
                                                "columns": [
                                                    47.0,
                                                    121.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 43.0,
                                                "columns": [
                                                    12.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -67.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 1677.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    237.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    195.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    48.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    150.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    140.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    166.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 51.0,
                                                "percent": 16.0
                                            },
                                            "compare": {
                                                "value": 44.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 47.0,
                                                "percent": -61.0
                                            },
                                            "compare": {
                                                "value": 121.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 208.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 237.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 195.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 150.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 140.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 166.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 125.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 144.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 16.0,
                                                "columns": [
                                                    51.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 41.0,
                                                "columns": [
                                                    15.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -23.0,
                                                "columns": [
                                                    2.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 648.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -61.0,
                                                "columns": [
                                                    47.0,
                                                    121.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 43.0,
                                                "columns": [
                                                    12.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -67.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 1677.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    237.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    195.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    48.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    150.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    140.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    166.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IBP",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 15.0,
                                                "percent": 41.0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 12.0,
                                                "percent": 43.0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 26.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 48.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 21.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 27.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 16.0,
                                                "columns": [
                                                    51.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 41.0,
                                                "columns": [
                                                    15.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -23.0,
                                                "columns": [
                                                    2.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 648.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -61.0,
                                                "columns": [
                                                    47.0,
                                                    121.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 43.0,
                                                "columns": [
                                                    12.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -67.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 1677.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    237.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    195.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    48.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    150.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    140.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    166.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "DSM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 2.0,
                                                "percent": -23.0
                                            },
                                            "compare": {
                                                "value": 3.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 2.0,
                                                "percent": -67.0
                                            },
                                            "compare": {
                                                "value": 7.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 16.0,
                                                "columns": [
                                                    51.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 41.0,
                                                "columns": [
                                                    15.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -23.0,
                                                "columns": [
                                                    2.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 648.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -61.0,
                                                "columns": [
                                                    47.0,
                                                    121.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 43.0,
                                                "columns": [
                                                    12.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -67.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 1677.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    237.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    195.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    48.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    150.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    140.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    166.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 648.0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 1677.0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 16.0,
                                                "columns": [
                                                    51.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 41.0,
                                                "columns": [
                                                    15.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -23.0,
                                                "columns": [
                                                    2.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 648.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -61.0,
                                                "columns": [
                                                    47.0,
                                                    121.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 43.0,
                                                "columns": [
                                                    12.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -67.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 1677.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    237.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    195.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    48.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    150.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    140.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    166.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 69.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 58.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 62.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 136.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 257.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 93.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 275.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 247.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 162.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 167.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 209.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 67.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 162.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 156.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -64.0,
                                                "columns": [
                                                    51.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 309.0,
                                                "columns": [
                                                    15.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -73.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -944.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -8.0,
                                                "columns": [
                                                    47.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -20.0,
                                                "columns": [
                                                    12.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 5.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -25.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 51.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 144.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 47.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 51.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 47.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -64.0,
                                                "columns": [
                                                    51.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 309.0,
                                                "columns": [
                                                    15.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -73.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -944.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -8.0,
                                                "columns": [
                                                    47.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -20.0,
                                                "columns": [
                                                    12.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 5.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -25.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IBP",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 15.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 12.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 12.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -64.0,
                                                "columns": [
                                                    51.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 309.0,
                                                "columns": [
                                                    15.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -73.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -944.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -8.0,
                                                "columns": [
                                                    47.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -20.0,
                                                "columns": [
                                                    12.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 5.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -25.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "DSM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -64.0,
                                                "columns": [
                                                    51.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 309.0,
                                                "columns": [
                                                    15.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -73.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -944.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -8.0,
                                                "columns": [
                                                    47.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -20.0,
                                                "columns": [
                                                    12.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 5.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -25.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -64.0,
                                                "columns": [
                                                    51.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 309.0,
                                                "columns": [
                                                    15.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -73.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -944.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -8.0,
                                                "columns": [
                                                    47.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -20.0,
                                                "columns": [
                                                    12.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 5.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -25.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 69.0,
                                                "percent": -31.0
                                            },
                                            "compare": {
                                                "value": 58.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 62.0,
                                                "percent": -31.0
                                            },
                                            "compare": {
                                                "value": 136.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 257.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 93.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 275.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 247.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 162.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 167.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 209.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 67.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 162.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 156.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -32.0,
                                                "columns": [
                                                    51.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 23.0,
                                                "columns": [
                                                    15.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -81.0,
                                                "columns": [
                                                    2.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -36.0,
                                                "columns": [
                                                    47.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 31.0,
                                                "columns": [
                                                    12.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -66.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    83.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 51.0,
                                                "percent": -32.0
                                            },
                                            "compare": {
                                                "value": 44.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 47.0,
                                                "percent": -36.0
                                            },
                                            "compare": {
                                                "value": 121.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 208.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 237.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 195.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 150.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 140.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 166.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 125.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 144.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -32.0,
                                                "columns": [
                                                    51.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 23.0,
                                                "columns": [
                                                    15.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -81.0,
                                                "columns": [
                                                    2.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -36.0,
                                                "columns": [
                                                    47.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 31.0,
                                                "columns": [
                                                    12.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -66.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    83.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IBP",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 15.0,
                                                "percent": 23.0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 12.0,
                                                "percent": 31.0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 26.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 48.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 21.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 27.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -32.0,
                                                "columns": [
                                                    51.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 23.0,
                                                "columns": [
                                                    15.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -81.0,
                                                "columns": [
                                                    2.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -36.0,
                                                "columns": [
                                                    47.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 31.0,
                                                "columns": [
                                                    12.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -66.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    83.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "DSM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 2.0,
                                                "percent": -81.0
                                            },
                                            "compare": {
                                                "value": 3.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 2.0,
                                                "percent": -66.0
                                            },
                                            "compare": {
                                                "value": 7.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -32.0,
                                                "columns": [
                                                    51.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 23.0,
                                                "columns": [
                                                    15.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -81.0,
                                                "columns": [
                                                    2.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -36.0,
                                                "columns": [
                                                    47.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 31.0,
                                                "columns": [
                                                    12.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -66.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    83.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -32.0,
                                                "columns": [
                                                    51.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 23.0,
                                                "columns": [
                                                    15.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -81.0,
                                                "columns": [
                                                    2.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -36.0,
                                                "columns": [
                                                    47.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 31.0,
                                                "columns": [
                                                    12.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -66.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    83.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                }
            ],
            "ytd": [
                {
                    "title": "LY",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 69.0,
                                                "percent": 19.0
                                            },
                                            "compare": {
                                                "value": 58.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 62.0,
                                                "percent": -55.0
                                            },
                                            "compare": {
                                                "value": 136.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 257.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 93.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 275.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 247.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 162.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 167.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 209.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 67.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 162.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 156.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 16.0,
                                                "columns": [
                                                    51.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 41.0,
                                                "columns": [
                                                    15.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -23.0,
                                                "columns": [
                                                    2.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 648.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -61.0,
                                                "columns": [
                                                    47.0,
                                                    121.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 43.0,
                                                "columns": [
                                                    12.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -67.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 1677.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    237.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    195.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    48.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    150.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    140.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    166.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 51.0,
                                                "percent": 16.0
                                            },
                                            "compare": {
                                                "value": 44.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 47.0,
                                                "percent": -61.0
                                            },
                                            "compare": {
                                                "value": 121.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 208.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 237.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 195.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 150.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 140.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 166.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 125.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 144.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 16.0,
                                                "columns": [
                                                    51.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 41.0,
                                                "columns": [
                                                    15.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -23.0,
                                                "columns": [
                                                    2.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 648.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -61.0,
                                                "columns": [
                                                    47.0,
                                                    121.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 43.0,
                                                "columns": [
                                                    12.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -67.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 1677.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    237.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    195.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    48.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    150.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    140.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    166.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IBP",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 15.0,
                                                "percent": 41.0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 12.0,
                                                "percent": 43.0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 26.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 48.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 21.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 27.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 16.0,
                                                "columns": [
                                                    51.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 41.0,
                                                "columns": [
                                                    15.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -23.0,
                                                "columns": [
                                                    2.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 648.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -61.0,
                                                "columns": [
                                                    47.0,
                                                    121.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 43.0,
                                                "columns": [
                                                    12.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -67.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 1677.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    237.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    195.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    48.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    150.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    140.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    166.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "DSM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 2.0,
                                                "percent": -23.0
                                            },
                                            "compare": {
                                                "value": 3.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 2.0,
                                                "percent": -67.0
                                            },
                                            "compare": {
                                                "value": 7.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 16.0,
                                                "columns": [
                                                    51.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 41.0,
                                                "columns": [
                                                    15.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -23.0,
                                                "columns": [
                                                    2.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 648.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -61.0,
                                                "columns": [
                                                    47.0,
                                                    121.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 43.0,
                                                "columns": [
                                                    12.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -67.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 1677.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    237.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    195.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    48.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    150.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    140.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    166.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 648.0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 1677.0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 16.0,
                                                "columns": [
                                                    51.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 41.0,
                                                "columns": [
                                                    15.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -23.0,
                                                "columns": [
                                                    2.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 648.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -61.0,
                                                "columns": [
                                                    47.0,
                                                    121.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 43.0,
                                                "columns": [
                                                    12.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -67.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 1677.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    237.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    195.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    48.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    150.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    140.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    166.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 69.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 58.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 62.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 136.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 257.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 93.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 275.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 247.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 162.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 167.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 209.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 67.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 162.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 156.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -64.0,
                                                "columns": [
                                                    51.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 309.0,
                                                "columns": [
                                                    15.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -73.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -944.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -8.0,
                                                "columns": [
                                                    47.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -20.0,
                                                "columns": [
                                                    12.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 5.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -25.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 51.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 144.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 47.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 51.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 47.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -64.0,
                                                "columns": [
                                                    51.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 309.0,
                                                "columns": [
                                                    15.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -73.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -944.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -8.0,
                                                "columns": [
                                                    47.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -20.0,
                                                "columns": [
                                                    12.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 5.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -25.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IBP",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 15.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 12.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 12.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -64.0,
                                                "columns": [
                                                    51.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 309.0,
                                                "columns": [
                                                    15.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -73.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -944.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -8.0,
                                                "columns": [
                                                    47.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -20.0,
                                                "columns": [
                                                    12.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 5.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -25.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "DSM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -64.0,
                                                "columns": [
                                                    51.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 309.0,
                                                "columns": [
                                                    15.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -73.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -944.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -8.0,
                                                "columns": [
                                                    47.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -20.0,
                                                "columns": [
                                                    12.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 5.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -25.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -64.0,
                                                "columns": [
                                                    51.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 309.0,
                                                "columns": [
                                                    15.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -73.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -944.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -8.0,
                                                "columns": [
                                                    47.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -20.0,
                                                "columns": [
                                                    12.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 5.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -25.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 69.0,
                                                "percent": -31.0
                                            },
                                            "compare": {
                                                "value": 58.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 62.0,
                                                "percent": -31.0
                                            },
                                            "compare": {
                                                "value": 136.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 257.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 93.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 275.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 247.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 162.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 167.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 209.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 67.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 162.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 156.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -32.0,
                                                "columns": [
                                                    51.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 23.0,
                                                "columns": [
                                                    15.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -81.0,
                                                "columns": [
                                                    2.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -36.0,
                                                "columns": [
                                                    47.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 31.0,
                                                "columns": [
                                                    12.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -66.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    83.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 51.0,
                                                "percent": -32.0
                                            },
                                            "compare": {
                                                "value": 44.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 47.0,
                                                "percent": -36.0
                                            },
                                            "compare": {
                                                "value": 121.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 208.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 237.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 195.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 150.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 140.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 166.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 125.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 144.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -32.0,
                                                "columns": [
                                                    51.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 23.0,
                                                "columns": [
                                                    15.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -81.0,
                                                "columns": [
                                                    2.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -36.0,
                                                "columns": [
                                                    47.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 31.0,
                                                "columns": [
                                                    12.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -66.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    83.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IBP",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 15.0,
                                                "percent": 23.0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 12.0,
                                                "percent": 31.0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 26.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 48.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 21.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 27.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -32.0,
                                                "columns": [
                                                    51.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 23.0,
                                                "columns": [
                                                    15.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -81.0,
                                                "columns": [
                                                    2.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -36.0,
                                                "columns": [
                                                    47.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 31.0,
                                                "columns": [
                                                    12.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -66.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    83.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "DSM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 2.0,
                                                "percent": -81.0
                                            },
                                            "compare": {
                                                "value": 3.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 2.0,
                                                "percent": -66.0
                                            },
                                            "compare": {
                                                "value": 7.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -32.0,
                                                "columns": [
                                                    51.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 23.0,
                                                "columns": [
                                                    15.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -81.0,
                                                "columns": [
                                                    2.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -36.0,
                                                "columns": [
                                                    47.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 31.0,
                                                "columns": [
                                                    12.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -66.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    83.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -32.0,
                                                "columns": [
                                                    51.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 23.0,
                                                "columns": [
                                                    15.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -81.0,
                                                "columns": [
                                                    2.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -36.0,
                                                "columns": [
                                                    47.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 31.0,
                                                "columns": [
                                                    12.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -66.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    83.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                }
            ],
        }
    },
    subMenu: [
        {
          // NavigationItem
          title: 'Total',
        },
        {
          // NavigationItem
          title: 'IL',
        },
        {
          // NavigationItem
          title: 'IBP',
        },
        {
          // NavigationItem
          title: 'DSM',
        },
        {
          // NavigationItem
          title: 'OTH',
        },
      ],
};

const oiPotashMock = {
    "title": "OI",
    "type": "OI",
    "navigation": {
        "type": "GraphNavigation",
        "nav": {
            "month": [
                {
                    "title": "LY",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 69.0,
                                                "percent": 19.0
                                            },
                                            "compare": {
                                                "value": 58.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 62.0,
                                                "percent": -55.0
                                            },
                                            "compare": {
                                                "value": 136.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 257.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 93.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 275.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 247.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 162.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 167.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 209.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 67.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 162.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 156.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 16.0,
                                                "columns": [
                                                    51.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 41.0,
                                                "columns": [
                                                    15.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -23.0,
                                                "columns": [
                                                    2.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 648.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -61.0,
                                                "columns": [
                                                    47.0,
                                                    121.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 43.0,
                                                "columns": [
                                                    12.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -67.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 1677.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    237.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    195.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    48.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    150.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    140.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    166.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 51.0,
                                                "percent": 16.0
                                            },
                                            "compare": {
                                                "value": 44.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 47.0,
                                                "percent": -61.0
                                            },
                                            "compare": {
                                                "value": 121.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 208.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 237.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 195.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 150.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 140.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 166.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 125.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 144.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 16.0,
                                                "columns": [
                                                    51.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 41.0,
                                                "columns": [
                                                    15.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -23.0,
                                                "columns": [
                                                    2.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 648.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -61.0,
                                                "columns": [
                                                    47.0,
                                                    121.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 43.0,
                                                "columns": [
                                                    12.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -67.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 1677.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    237.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    195.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    48.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    150.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    140.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    166.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IBP",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 15.0,
                                                "percent": 41.0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 12.0,
                                                "percent": 43.0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 26.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 48.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 21.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 27.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 16.0,
                                                "columns": [
                                                    51.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 41.0,
                                                "columns": [
                                                    15.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -23.0,
                                                "columns": [
                                                    2.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 648.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -61.0,
                                                "columns": [
                                                    47.0,
                                                    121.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 43.0,
                                                "columns": [
                                                    12.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -67.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 1677.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    237.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    195.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    48.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    150.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    140.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    166.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "DSM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 2.0,
                                                "percent": -23.0
                                            },
                                            "compare": {
                                                "value": 3.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 2.0,
                                                "percent": -67.0
                                            },
                                            "compare": {
                                                "value": 7.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 16.0,
                                                "columns": [
                                                    51.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 41.0,
                                                "columns": [
                                                    15.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -23.0,
                                                "columns": [
                                                    2.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 648.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -61.0,
                                                "columns": [
                                                    47.0,
                                                    121.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 43.0,
                                                "columns": [
                                                    12.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -67.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 1677.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    237.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    195.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    48.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    150.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    140.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    166.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 648.0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 1677.0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 16.0,
                                                "columns": [
                                                    51.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 41.0,
                                                "columns": [
                                                    15.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -23.0,
                                                "columns": [
                                                    2.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 648.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -61.0,
                                                "columns": [
                                                    47.0,
                                                    121.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 43.0,
                                                "columns": [
                                                    12.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -67.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 1677.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    237.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    195.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    48.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    150.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    140.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    166.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 69.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 58.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 62.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 136.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 257.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 93.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 275.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 247.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 162.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 167.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 209.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 67.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 162.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 156.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -64.0,
                                                "columns": [
                                                    51.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 309.0,
                                                "columns": [
                                                    15.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -73.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -944.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -8.0,
                                                "columns": [
                                                    47.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -20.0,
                                                "columns": [
                                                    12.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 5.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -25.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 51.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 144.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 47.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 51.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 47.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -64.0,
                                                "columns": [
                                                    51.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 309.0,
                                                "columns": [
                                                    15.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -73.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -944.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -8.0,
                                                "columns": [
                                                    47.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -20.0,
                                                "columns": [
                                                    12.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 5.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -25.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IBP",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 15.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 12.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 12.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -64.0,
                                                "columns": [
                                                    51.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 309.0,
                                                "columns": [
                                                    15.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -73.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -944.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -8.0,
                                                "columns": [
                                                    47.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -20.0,
                                                "columns": [
                                                    12.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 5.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -25.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "DSM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -64.0,
                                                "columns": [
                                                    51.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 309.0,
                                                "columns": [
                                                    15.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -73.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -944.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -8.0,
                                                "columns": [
                                                    47.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -20.0,
                                                "columns": [
                                                    12.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 5.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -25.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -64.0,
                                                "columns": [
                                                    51.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 309.0,
                                                "columns": [
                                                    15.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -73.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -944.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -8.0,
                                                "columns": [
                                                    47.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -20.0,
                                                "columns": [
                                                    12.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 5.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -25.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 69.0,
                                                "percent": -31.0
                                            },
                                            "compare": {
                                                "value": 58.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 62.0,
                                                "percent": -31.0
                                            },
                                            "compare": {
                                                "value": 136.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 257.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 93.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 275.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 247.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 162.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 167.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 209.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 67.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 162.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 156.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -32.0,
                                                "columns": [
                                                    51.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 23.0,
                                                "columns": [
                                                    15.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -81.0,
                                                "columns": [
                                                    2.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -36.0,
                                                "columns": [
                                                    47.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 31.0,
                                                "columns": [
                                                    12.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -66.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    83.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 51.0,
                                                "percent": -32.0
                                            },
                                            "compare": {
                                                "value": 44.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 47.0,
                                                "percent": -36.0
                                            },
                                            "compare": {
                                                "value": 121.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 208.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 237.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 195.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 150.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 140.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 166.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 125.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 144.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -32.0,
                                                "columns": [
                                                    51.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 23.0,
                                                "columns": [
                                                    15.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -81.0,
                                                "columns": [
                                                    2.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -36.0,
                                                "columns": [
                                                    47.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 31.0,
                                                "columns": [
                                                    12.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -66.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    83.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IBP",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 15.0,
                                                "percent": 23.0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 12.0,
                                                "percent": 31.0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 26.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 48.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 21.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 27.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -32.0,
                                                "columns": [
                                                    51.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 23.0,
                                                "columns": [
                                                    15.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -81.0,
                                                "columns": [
                                                    2.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -36.0,
                                                "columns": [
                                                    47.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 31.0,
                                                "columns": [
                                                    12.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -66.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    83.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "DSM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 2.0,
                                                "percent": -81.0
                                            },
                                            "compare": {
                                                "value": 3.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 2.0,
                                                "percent": -66.0
                                            },
                                            "compare": {
                                                "value": 7.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -32.0,
                                                "columns": [
                                                    51.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 23.0,
                                                "columns": [
                                                    15.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -81.0,
                                                "columns": [
                                                    2.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -36.0,
                                                "columns": [
                                                    47.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 31.0,
                                                "columns": [
                                                    12.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -66.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    83.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -32.0,
                                                "columns": [
                                                    51.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 23.0,
                                                "columns": [
                                                    15.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -81.0,
                                                "columns": [
                                                    2.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -36.0,
                                                "columns": [
                                                    47.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 31.0,
                                                "columns": [
                                                    12.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -66.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    83.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                }
            ],
            "qtd": [
                {
                    "title": "LY",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 69.0,
                                                "percent": 19.0
                                            },
                                            "compare": {
                                                "value": 58.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 62.0,
                                                "percent": -55.0
                                            },
                                            "compare": {
                                                "value": 136.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 257.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 93.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 275.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 247.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 162.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 167.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 209.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 67.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 162.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 156.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 16.0,
                                                "columns": [
                                                    51.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 41.0,
                                                "columns": [
                                                    15.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -23.0,
                                                "columns": [
                                                    2.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 648.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -61.0,
                                                "columns": [
                                                    47.0,
                                                    121.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 43.0,
                                                "columns": [
                                                    12.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -67.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 1677.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    237.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    195.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    48.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    150.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    140.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    166.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 51.0,
                                                "percent": 16.0
                                            },
                                            "compare": {
                                                "value": 44.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 47.0,
                                                "percent": -61.0
                                            },
                                            "compare": {
                                                "value": 121.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 208.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 237.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 195.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 150.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 140.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 166.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 125.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 144.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 16.0,
                                                "columns": [
                                                    51.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 41.0,
                                                "columns": [
                                                    15.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -23.0,
                                                "columns": [
                                                    2.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 648.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -61.0,
                                                "columns": [
                                                    47.0,
                                                    121.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 43.0,
                                                "columns": [
                                                    12.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -67.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 1677.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    237.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    195.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    48.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    150.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    140.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    166.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IBP",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 15.0,
                                                "percent": 41.0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 12.0,
                                                "percent": 43.0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 26.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 48.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 21.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 27.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 16.0,
                                                "columns": [
                                                    51.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 41.0,
                                                "columns": [
                                                    15.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -23.0,
                                                "columns": [
                                                    2.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 648.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -61.0,
                                                "columns": [
                                                    47.0,
                                                    121.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 43.0,
                                                "columns": [
                                                    12.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -67.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 1677.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    237.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    195.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    48.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    150.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    140.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    166.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "DSM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 2.0,
                                                "percent": -23.0
                                            },
                                            "compare": {
                                                "value": 3.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 2.0,
                                                "percent": -67.0
                                            },
                                            "compare": {
                                                "value": 7.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 16.0,
                                                "columns": [
                                                    51.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 41.0,
                                                "columns": [
                                                    15.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -23.0,
                                                "columns": [
                                                    2.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 648.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -61.0,
                                                "columns": [
                                                    47.0,
                                                    121.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 43.0,
                                                "columns": [
                                                    12.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -67.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 1677.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    237.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    195.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    48.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    150.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    140.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    166.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 648.0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 1677.0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 16.0,
                                                "columns": [
                                                    51.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 41.0,
                                                "columns": [
                                                    15.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -23.0,
                                                "columns": [
                                                    2.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 648.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -61.0,
                                                "columns": [
                                                    47.0,
                                                    121.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 43.0,
                                                "columns": [
                                                    12.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -67.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 1677.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    237.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    195.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    48.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    150.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    140.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    166.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 69.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 58.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 62.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 136.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 257.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 93.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 275.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 247.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 162.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 167.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 209.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 67.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 162.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 156.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -64.0,
                                                "columns": [
                                                    51.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 309.0,
                                                "columns": [
                                                    15.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -73.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -944.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -8.0,
                                                "columns": [
                                                    47.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -20.0,
                                                "columns": [
                                                    12.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 5.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -25.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 51.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 144.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 47.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 51.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 47.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -64.0,
                                                "columns": [
                                                    51.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 309.0,
                                                "columns": [
                                                    15.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -73.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -944.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -8.0,
                                                "columns": [
                                                    47.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -20.0,
                                                "columns": [
                                                    12.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 5.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -25.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IBP",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 15.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 12.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 12.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -64.0,
                                                "columns": [
                                                    51.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 309.0,
                                                "columns": [
                                                    15.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -73.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -944.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -8.0,
                                                "columns": [
                                                    47.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -20.0,
                                                "columns": [
                                                    12.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 5.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -25.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "DSM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -64.0,
                                                "columns": [
                                                    51.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 309.0,
                                                "columns": [
                                                    15.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -73.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -944.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -8.0,
                                                "columns": [
                                                    47.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -20.0,
                                                "columns": [
                                                    12.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 5.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -25.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -64.0,
                                                "columns": [
                                                    51.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 309.0,
                                                "columns": [
                                                    15.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -73.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -944.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -8.0,
                                                "columns": [
                                                    47.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -20.0,
                                                "columns": [
                                                    12.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 5.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -25.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 69.0,
                                                "percent": -31.0
                                            },
                                            "compare": {
                                                "value": 58.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 62.0,
                                                "percent": -31.0
                                            },
                                            "compare": {
                                                "value": 136.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 257.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 93.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 275.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 247.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 162.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 167.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 209.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 67.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 162.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 156.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -32.0,
                                                "columns": [
                                                    51.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 23.0,
                                                "columns": [
                                                    15.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -81.0,
                                                "columns": [
                                                    2.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -36.0,
                                                "columns": [
                                                    47.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 31.0,
                                                "columns": [
                                                    12.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -66.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    83.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 51.0,
                                                "percent": -32.0
                                            },
                                            "compare": {
                                                "value": 44.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 47.0,
                                                "percent": -36.0
                                            },
                                            "compare": {
                                                "value": 121.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 208.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 237.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 195.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 150.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 140.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 166.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 125.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 144.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -32.0,
                                                "columns": [
                                                    51.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 23.0,
                                                "columns": [
                                                    15.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -81.0,
                                                "columns": [
                                                    2.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -36.0,
                                                "columns": [
                                                    47.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 31.0,
                                                "columns": [
                                                    12.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -66.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    83.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IBP",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 15.0,
                                                "percent": 23.0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 12.0,
                                                "percent": 31.0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 26.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 48.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 21.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 27.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -32.0,
                                                "columns": [
                                                    51.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 23.0,
                                                "columns": [
                                                    15.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -81.0,
                                                "columns": [
                                                    2.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -36.0,
                                                "columns": [
                                                    47.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 31.0,
                                                "columns": [
                                                    12.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -66.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    83.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "DSM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 2.0,
                                                "percent": -81.0
                                            },
                                            "compare": {
                                                "value": 3.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 2.0,
                                                "percent": -66.0
                                            },
                                            "compare": {
                                                "value": 7.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -32.0,
                                                "columns": [
                                                    51.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 23.0,
                                                "columns": [
                                                    15.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -81.0,
                                                "columns": [
                                                    2.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -36.0,
                                                "columns": [
                                                    47.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 31.0,
                                                "columns": [
                                                    12.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -66.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    83.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -32.0,
                                                "columns": [
                                                    51.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 23.0,
                                                "columns": [
                                                    15.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -81.0,
                                                "columns": [
                                                    2.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -36.0,
                                                "columns": [
                                                    47.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 31.0,
                                                "columns": [
                                                    12.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -66.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    83.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                }
            ],
            "ytd": [
                {
                    "title": "LY",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 69.0,
                                                "percent": 19.0
                                            },
                                            "compare": {
                                                "value": 58.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 62.0,
                                                "percent": -55.0
                                            },
                                            "compare": {
                                                "value": 136.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 257.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 93.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 275.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 247.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 162.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 167.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 209.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 67.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 162.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 156.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 16.0,
                                                "columns": [
                                                    51.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 41.0,
                                                "columns": [
                                                    15.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -23.0,
                                                "columns": [
                                                    2.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 648.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -61.0,
                                                "columns": [
                                                    47.0,
                                                    121.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 43.0,
                                                "columns": [
                                                    12.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -67.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 1677.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    237.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    195.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    48.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    150.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    140.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    166.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 51.0,
                                                "percent": 16.0
                                            },
                                            "compare": {
                                                "value": 44.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 47.0,
                                                "percent": -61.0
                                            },
                                            "compare": {
                                                "value": 121.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 208.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 237.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 195.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 150.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 140.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 166.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 125.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 144.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 16.0,
                                                "columns": [
                                                    51.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 41.0,
                                                "columns": [
                                                    15.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -23.0,
                                                "columns": [
                                                    2.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 648.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -61.0,
                                                "columns": [
                                                    47.0,
                                                    121.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 43.0,
                                                "columns": [
                                                    12.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -67.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 1677.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    237.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    195.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    48.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    150.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    140.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    166.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IBP",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 15.0,
                                                "percent": 41.0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 12.0,
                                                "percent": 43.0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 26.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 48.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 21.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 27.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 16.0,
                                                "columns": [
                                                    51.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 41.0,
                                                "columns": [
                                                    15.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -23.0,
                                                "columns": [
                                                    2.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 648.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -61.0,
                                                "columns": [
                                                    47.0,
                                                    121.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 43.0,
                                                "columns": [
                                                    12.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -67.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 1677.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    237.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    195.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    48.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    150.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    140.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    166.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "DSM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 2.0,
                                                "percent": -23.0
                                            },
                                            "compare": {
                                                "value": 3.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 2.0,
                                                "percent": -67.0
                                            },
                                            "compare": {
                                                "value": 7.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 16.0,
                                                "columns": [
                                                    51.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 41.0,
                                                "columns": [
                                                    15.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -23.0,
                                                "columns": [
                                                    2.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 648.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -61.0,
                                                "columns": [
                                                    47.0,
                                                    121.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 43.0,
                                                "columns": [
                                                    12.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -67.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 1677.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    237.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    195.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    48.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    150.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    140.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    166.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 648.0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 1677.0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 16.0,
                                                "columns": [
                                                    51.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 41.0,
                                                "columns": [
                                                    15.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -23.0,
                                                "columns": [
                                                    2.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 648.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -61.0,
                                                "columns": [
                                                    47.0,
                                                    121.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 43.0,
                                                "columns": [
                                                    12.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -67.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 1677.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    237.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    195.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    48.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    150.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    140.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    166.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 69.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 58.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 62.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 136.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 257.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 93.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 275.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 247.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 162.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 167.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 209.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 67.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 162.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 156.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -64.0,
                                                "columns": [
                                                    51.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 309.0,
                                                "columns": [
                                                    15.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -73.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -944.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -8.0,
                                                "columns": [
                                                    47.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -20.0,
                                                "columns": [
                                                    12.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 5.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -25.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 51.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 144.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 47.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 51.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 47.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -64.0,
                                                "columns": [
                                                    51.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 309.0,
                                                "columns": [
                                                    15.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -73.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -944.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -8.0,
                                                "columns": [
                                                    47.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -20.0,
                                                "columns": [
                                                    12.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 5.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -25.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IBP",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 15.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 12.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 12.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -64.0,
                                                "columns": [
                                                    51.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 309.0,
                                                "columns": [
                                                    15.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -73.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -944.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -8.0,
                                                "columns": [
                                                    47.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -20.0,
                                                "columns": [
                                                    12.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 5.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -25.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "DSM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -64.0,
                                                "columns": [
                                                    51.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 309.0,
                                                "columns": [
                                                    15.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -73.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -944.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -8.0,
                                                "columns": [
                                                    47.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -20.0,
                                                "columns": [
                                                    12.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 5.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -25.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -64.0,
                                                "columns": [
                                                    51.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 309.0,
                                                "columns": [
                                                    15.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -73.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -944.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -8.0,
                                                "columns": [
                                                    47.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": -20.0,
                                                "columns": [
                                                    12.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 5.0,
                                                "columns": [
                                                    2.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -25.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 69.0,
                                                "percent": -31.0
                                            },
                                            "compare": {
                                                "value": 58.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 62.0,
                                                "percent": -31.0
                                            },
                                            "compare": {
                                                "value": 136.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 257.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 93.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 275.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 247.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 162.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 167.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 209.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 67.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 162.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 156.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -32.0,
                                                "columns": [
                                                    51.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 23.0,
                                                "columns": [
                                                    15.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -81.0,
                                                "columns": [
                                                    2.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -36.0,
                                                "columns": [
                                                    47.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 31.0,
                                                "columns": [
                                                    12.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -66.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    83.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 51.0,
                                                "percent": -32.0
                                            },
                                            "compare": {
                                                "value": 44.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 47.0,
                                                "percent": -36.0
                                            },
                                            "compare": {
                                                "value": 121.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 208.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 237.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 195.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 150.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 140.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 166.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 125.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 144.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -32.0,
                                                "columns": [
                                                    51.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 23.0,
                                                "columns": [
                                                    15.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -81.0,
                                                "columns": [
                                                    2.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -36.0,
                                                "columns": [
                                                    47.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 31.0,
                                                "columns": [
                                                    12.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -66.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    83.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "IBP",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 15.0,
                                                "percent": 23.0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 12.0,
                                                "percent": 31.0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 26.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 48.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 21.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 27.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -32.0,
                                                "columns": [
                                                    51.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 23.0,
                                                "columns": [
                                                    15.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -81.0,
                                                "columns": [
                                                    2.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -36.0,
                                                "columns": [
                                                    47.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 31.0,
                                                "columns": [
                                                    12.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -66.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    83.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "DSM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 2.0,
                                                "percent": -81.0
                                            },
                                            "compare": {
                                                "value": 3.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 2.0,
                                                "percent": -66.0
                                            },
                                            "compare": {
                                                "value": 7.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -32.0,
                                                "columns": [
                                                    51.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 23.0,
                                                "columns": [
                                                    15.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -81.0,
                                                "columns": [
                                                    2.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -36.0,
                                                "columns": [
                                                    47.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 31.0,
                                                "columns": [
                                                    12.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -66.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    83.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -32.0,
                                                "columns": [
                                                    51.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 23.0,
                                                "columns": [
                                                    15.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -81.0,
                                                "columns": [
                                                    2.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": -36.0,
                                                "columns": [
                                                    47.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 31.0,
                                                "columns": [
                                                    12.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": -66.0,
                                                "columns": [
                                                    2.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0,
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    83.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "IBP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            },
                                            {
                                                "title": "DSM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                }
            ],
        }
    },
    subMenu: [
        {
          // NavigationItem
          title: 'Total',
        },
        {
          // NavigationItem
          title: 'IL',
        },
        {
          // NavigationItem
          title: 'IBP',
        },
        {
          // NavigationItem
          title: 'DSM',
        },
        {
          // NavigationItem
          title: 'OTH',
        },
      ],
};

export const PothasGhraphsMock = [
    salesPotashMock,
    ebitdaPotashMock,
    oiPotashMock,
    ProductionDivisionMock
];